import { NgModule } from '@angular/core';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { ColectivosRoutingModule } from './routing';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { MatDialogActions } from '@angular/material/dialog';
import { ListadoCronogramasComponent } from './cronogramas/listado-cronogramas/listado-cronogramas.component';
import { CrearEditarCronogramaComponent } from './cronogramas/crear-editar-cronograma/crear-editar-cronograma.component';
import { ListadoColectivosComponent } from './colectivos/listado-colectivos/listado-colectivos.component';
import { SetearOdometroComponent } from './colectivos/listado-colectivos/setear-odometro/setear-odometro.component';
import { CrearEditarColectivoComponent } from './colectivos/crear-editar-colectivo/crear-editar-colectivo.component';
import { ListadoRecorridosComponent } from './recorridos/listado-recorridos/listado-recorridos.component';
import { CrearEditarRecorridoComponent } from './recorridos/crear-editar-recorrido/crear-editar-recorrido.component';
// import { MapaParadasOlComponent } from './recorridos/mapa-paradas-ol/mapa-paradas-ol.component'; // REMOVED: Legacy OpenLayers component
import { MapaParadasMapboxComponent } from './recorridos/mapa-paradas-mapbox/mapa-paradas-mapbox.component';
import { UploadFileComponent } from '../../../auxiliares/upload-file/upload-file.component';
import { MapaColectivosComponent } from './mapa-colectivos/mapa-colectivos.component';
import { FlotanteComponent } from './mapa-colectivos/flotante/flotante.component';
import { PopupComponent } from './mapa-colectivos/popup/popup.component';
import { DespachosModule } from './despachos/despachos.module';
import { DetallesColectivoComponent } from './colectivos/detalles-colectivo/detalles-colectivo.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ListadoConfigEventoUsuarioComponent } from '../../standalone/config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { DetallesColectivoInfoComponent } from './colectivos/detalles-colectivo-info/detalles-colectivo-info.component';
import { DetallesTrackeosComponent } from './colectivos/detalles-colectivo-viajes/detalles-trackeos/detalles-trackeos.component';
import { ListadoLogsTrackeosComponent } from './colectivos/detalles-colectivo-viajes/listado-logs-trackeos/listado-logs-trackeos.component';
import { ListadoTrackeosComponent } from './colectivos/detalles-colectivo-viajes/listado-trackeos/listado-trackeos.component';
import { ControlesComponent } from './colectivos/detalles-colectivo-viajes/viajes-paradas/controles/controles.component';
import { ParadaComponent } from './colectivos/detalles-colectivo-viajes/viajes-paradas/controles/parada/parada.component';
import { ViajeComponent } from './colectivos/detalles-colectivo-viajes/viajes-paradas/controles/viaje/viaje.component';
import { ViajesParadasComponent } from './colectivos/detalles-colectivo-viajes/viajes-paradas/viajes-paradas.component';
import { ListadoDocumentosComponent } from '../../standalone/documentos/listado-documentos/listado-documentos.component';
import { DarAltaColectivoComponent } from './dar-alta-colectivo/dar-alta-colectivo.component';
import { MapaUbicarComponent } from '../../../auxiliares/mapas/mapa-ubicar/mapa-ubicar.component';
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
// MapaCreadorComponent (OpenLayers) removido - reemplazado por MapaCreadorMapboxComponent
import { MapaCreadorMapboxComponent } from '../../../auxiliares/mapa-creador-mapbox/mapa-creador-mapbox.component';
import { CrearEditarRecordatorioComponent } from '../../standalone/recordatorios/crear-editar-recordatorio/crear-editar-recordatorio.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AdministracionModule } from '../administracion/module';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { ConfigHorariosAtencionComponent } from '../../standalone/config-horarios-atencion/config-horarios-atencion.component';
import { InfoBannerComponent } from '../../../componentes/info-banner/info-banner.component';
import { PasosNavComponent } from '../../../componentes/formularios/pasos-nav/pasos-nav.component';

@NgModule({
  declarations: [
    //Mapa
    MapaColectivosComponent,
    FlotanteComponent,
    PopupComponent,

    //Cronogramas
    ListadoCronogramasComponent,
    CrearEditarCronogramaComponent,

    //Colectivos
    ListadoColectivosComponent,
    SetearOdometroComponent,
    DetallesColectivoInfoComponent,
    DetallesColectivoComponent,
    ViajesParadasComponent,
    ControlesComponent,
    ViajeComponent,
    ParadaComponent,
    ListadoTrackeosComponent,
    ListadoLogsTrackeosComponent,
    DetallesTrackeosComponent,
    CrearEditarColectivoComponent,
    CrearEditarRecordatorioComponent,
    //Recorridos
    ListadoRecorridosComponent,
    CrearEditarRecorridoComponent,
    // MapaParadasOlComponent removido - componente legacy OpenLayers no usado
    MapaParadasMapboxComponent,
    // Dar Alta
    DarAltaColectivoComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    ColectivosRoutingModule,
    MapaUnicoPuntoComponent,
    MapaFacilComponent,
    MapaFacilV2Component,
    DateRangeSelectorComponent,
    MatDialogActions,
    UploadFileComponent,
    DespachosModule,
    DespachosModule,
    ListadoConfigsEventosComponent,
    ListadoConfigEventoUsuarioComponent,
    ListadoNotasComponent,
    ListadoDocumentosComponent,
    MapaUbicarComponent,
    JerarquiaClienteComponent,
    SelectorTipoMapaComponent,
    CardComponent,
    MapaCreadorMapboxComponent,
    EventosGenericosModule,
    AdministracionModule,
    MapCardComponent,
    ConfigHorariosAtencionComponent,
    InfoBannerComponent,
    PasosNavComponent,
    ...PIEZAS_DETALLE,
  ],
})
export class ColectivosModule {}
